import '../styles/banner.css'

const Banner = () => {
  return (
    <div className="banner">
      <span role="img" aria-label="snowy lake basin at sunrise surrounded by jagged mountains"></span>
      <div className="banner-subtitle">
        <p>The mountains are calling and I must go.</p>
      </div>
    </div>
  );
};

export default Banner;
